export default "__VITE_ASSET__c0f39644__"